import type { IPublicClientApplication, SilentRequest } from '@azure/msal-browser'
import { apiScopes } from '../config/auth'

let _msalInstance: IPublicClientApplication | null = null

export function initializeTokenService(msalInstance: IPublicClientApplication): void {
  _msalInstance = msalInstance
}

export async function acquireAccessToken(): Promise<string | null> {
  if (!_msalInstance) {
    console.error('Token service not initialized. Ensure initializeTokenService is called.')
    return null
  }

  const account = _msalInstance.getActiveAccount()
  if (!account) {
    console.error('No active account. User may not be logged in.')
    return null
  }

  try {
    const request: SilentRequest = {
      ...apiScopes,
      account,
    }
    const response = await _msalInstance.acquireTokenSilent(request)
    return response.accessToken
  } catch {
    try {
      const response = await _msalInstance.acquireTokenPopup(apiScopes)
      return response.accessToken
    } catch (popupError) {
      console.error('Token acquisition failed:', popupError)
      return null
    }
  }
}
